import React, { Fragment } from 'react';
import { FaCheckSquare, FaRegSquare } from 'react-icons/fa';

import Lock from '../../images/lock.svg';

const PackageCard = ({ img, title, selected, click, name, status }) => {
  return (
    <Fragment>
      {status ? (
        <div onClick={click} className="flex cursor-pointer">
          <span className="text-cf-300 text-2xl">
            {selected ? <FaCheckSquare /> : <FaRegSquare />}
          </span>
          <div className="rounded w-80 h-56 bg-gray-100 p-4 text-center border border-cf-300 text-sm shadow-cfw">
            <p className="font-header text-base mb-2">{title}</p>
            <img className="mx-auto w-32" src={img} alt="Crop" />
            <div>
              <p className="text-sm">{name}</p>
              <p className="text-sm text-cf-300">Available</p>
            </div>
          </div>
        </div>
      ) : (
        <div className="relative flex cursor-not-allowed">
          <div className="rounded w-80 bg-gray-100 p-4 text-center text-sm opacity-25 text-gray-400 shadow-cfw border border-cf-300">
            <p className="font-header text-base mb-2">{title}</p>
            <img className="mx-auto w-32" src={img} alt="Crop" />
            <ul>
              <li>Price per acre</li>
              <li>Low risk profile</li>
              <li>Normal margins</li>
            </ul>
          </div>
          <div className="absolute bottom-0 left-0 right-0 top-0 z-40 mx-auto pt-10">
            <img className="w-ull mx-auto" src={Lock} alt="Locker" />
            <div className="rounded border border-cf-300 p-2 w-32 bg-cf-200 mx-auto text-cf-300">
              <p>Not Available</p>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default PackageCard;
